import React, {useEffect, useState} from 'react';
import {
  View,
  Text,
  useWindowDimensions,
  TextStyle,
  ViewStyle,
} from 'react-native';

import {
  SignIn,
  FAQ,
  Testimonials,
  Features,
  AIAction,
  Hero,
  SignUpModal,
  Footer,
} from 'components/landing_page';
import {spacing} from 'theme/Units';
import {colors} from 'theme/Colors';
import {mergeDeepRight} from 'ramda';
import {logLandingPageVisitEvent} from 'services/firebase';
import {Routes, RootNavigatorParams} from 'navigation/Routes';
import {NativeStackScreenProps} from '@react-navigation/native-stack';

export const LandingScreen = ({
  navigation,
}: NativeStackScreenProps<RootNavigatorParams>) => {
  const [modalOpen, setModalOpen] = useState(false);

  function openModal() {
    setModalOpen(true);
  }

  function closeModal() {
    setModalOpen(false);
  }

  function nagivateToLogin() {
    navigation.navigate(Routes.LOGIN);
  }
  function nagivateToSignup() {
    navigation.navigate(Routes.SIGN_UP);
  }

  /**
   * responsiveness logic
   */
  const SCREEN_WIDTH = useWindowDimensions().width;
  let overrideStyles = structuredClone(baseStyles);

  if (SCREEN_WIDTH < 720) {
    overrideStyles.heading.fontSize = 40;
    overrideStyles.normal.fontSize = 18;
  }
  if (SCREEN_WIDTH < 640) {
    overrideStyles.heading.fontSize = 35;
    overrideStyles.action_heading.padding = spacing['6'];
    overrideStyles.normal.fontSize = 16;
  }
  if (SCREEN_WIDTH < 480) {
    overrideStyles.heading.fontSize = 30;
    overrideStyles.action_heading.padding = spacing['4'];
    overrideStyles.normal.fontSize = 14;
  }
  if (SCREEN_WIDTH < 360) {
    overrideStyles.heading.fontSize = 24;
    overrideStyles.action_heading.padding = spacing['2'];
    overrideStyles.normal.fontSize = 12;
  }

  const styles: styleType = mergeDeepRight(baseStyles, overrideStyles) as any;

  useEffect(() => {
    // logging event for landing page visit
    logLandingPageVisitEvent();
  }, []);

  return (
    <View style={styles.container}>
      {/* Hero section */}
      <Hero nagivateToLogin={nagivateToLogin} nagivateToSignup={nagivateToSignup} openModal={openModal} />

      {/* action heading */}
      <View style={styles.action_heading}>
        <Text style={styles.heading}>
          Empowering
          <Text style={styles.brandPink}> Automation </Text>
          With AI Agents
        </Text>

        <Text style={styles.normal}>
          Our AI agent isn’t just a feature—it’s the backbone of every
          offering,driving{'\n'}unparalleled efficiency and innovation
        </Text>
      </View>

      {/* AI action  */}
      <AIAction openModal={openModal} />

      {/* AI action  */}
      <View style={styles.action_heading}>
        <Text style={styles.heading}>
          Unlock the Extraordinary with
          <Text style={[styles.heading, styles.brandPink]}>
            1IDP
          </Text>
        </Text>

        <Text style={styles.normal}>
          Transform the way your development teams work. Discover the{' '}
          <Text style={styles.brandBlue}>key benefits</Text>{' '}
          that make 1IDP the{'\n'}ultimate partner in innovation, efficiency,
          and success
        </Text>
      </View>

      {/* Features section */}
      <Features openModal={openModal} />

      {/* Testimonial section */}
      <Testimonials openModal={openModal} />

      {/* FAQ section */}
      <FAQ />

      {/* Sign in section */}
      <SignIn openModal={openModal} />

      {/* Footer section */}
      <Footer />

      <SignUpModal visible={modalOpen} onClose={closeModal} />
    </View>
  );
};

type styleType = {
  container: ViewStyle;
  action_heading: ViewStyle;
  heading: TextStyle;
  normal: TextStyle;
  feature_heading: ViewStyle;
  brandPink: TextStyle;
  brandBlue: TextStyle;
};

const baseStyles: styleType = {
  brandPink: {color: colors.palette.brandPink},
  brandBlue: {color: colors.palette.brandBlue},
  container: {
    flex: 1,
    backgroundColor: 'white',
  },
  action_heading: {
    padding: spacing['8'],
    alignItems: 'center',
    gap: spacing['4'],
  },
  heading: {
    fontSize: 50,
    fontWeight: '700',
    textAlign: 'center',
  },
  normal: {
    textAlign: 'center',
    fontSize: 20,
    color: '#393C46',
    fontWeight: '500',
  },
  feature_heading: {
    paddingVertical: 64,
    alignItems: 'center',
    gap: spacing['4'],
  },
};
